import * as React from 'react';

export class Catch extends React.Component<
    {
        text?: string;
        renderError?: Function;
        sendReport?: boolean;
        showRefreshPageButton?: boolean;
        children?: React.ReactNode;
    },
    {
        hasError: boolean;
    }
> {
    static defaultProps = {
        text: kuura.getMessage('js_popup.default_error'),
        sendReport: true,
        showRefreshPageButton: false,
        showInline: false,
    };
    state = {
        hasError: false,
    };

    componentDidCatch(error, info) {
        this.setState({
            hasError: true,
        });
    }

    render() {
        if (this.state.hasError) {
            if (typeof this.props.renderError === 'function') {
                return this.props.renderError();
            }
            return (
                <div style={wrapperStyle as React.CSSProperties}>
                    <h6>{this.props.text}</h6>
                    {this.props.sendReport && <div>Error report was sent</div>}
                </div>
            );
        }

        return this.props.children;
    }
}

const wrapperStyle = {
    margin: 'auto',
    padding: '1em',
    textAlign: 'center',
};
